// @ts-nocheck
import React from "react";
import { SecondaryBtn } from "./SecondaryBtn";
import { DangerBtn } from "./DangerBtn";
import PropTypes from "prop-types";
import style from "./InfoCard.module.scss";
import { getImageUrl } from "../../../commons/assets_path";
import { useTranslation } from "react-i18next";

export const InfoCard = ({
  card,
  isDelete = false,
  loading = false,
  deleteFunc = null,
  changeFunc = null,
  paymentMethod,
  styles = {},
  currentPlan,
  is_internal = true,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={`d-flex align-items-center ${style.card}`} style={styles}>
        {paymentMethod === "send_invoice" ? (
          <>
            <div className={`d-flex flex-column ${style.cardInfo}`}>
              <span className="test-card-number">{t("InfoCard.請求書払い")}</span>
            </div>
            <div className="ml-auto">
              <SecondaryBtn
                text={t("InfoCard.変更")}
                submit={changeFunc}
                className="test-change-card mx-1"
                disabled={loading ? true : false}
                style={{
                  padding: "3px 10px",
                  borderRadius: "30px",
                  minWidth: "68px",
                  minHeight: "38px",
                  fontWeight: 600,
                  height: "auto",
                }}
                data-testid="test-change-card-info-btn"
              />
            </div>
          </>
        ) : (
          <>
            {card ? (
              <>
                <div className={style.cardImg}>
                  {card.brand === "Visa" ? (
                    <img src={getImageUrl("images/icons/brand/Visa.png")} height="28" />
                  ) : card.brand === "MasterCard" ? (
                    <img
                      src={getImageUrl("images/icons/brand/MasterCard.png")}
                      height="28"
                      className={`${style.mc} mr-3`}
                    />
                  ) : card.brand === "JCB" ? (
                    <img src={getImageUrl("images/icons/brand/JCB.png")} height="28" />
                  ) : card.brand === "American Express" ? (
                    <img
                      src={getImageUrl("images/icons/brand/AmericanExpress.png")}
                      height="28"
                      className={`${style.amex} mr-3`}
                    />
                  ) : (
                    <img src={getImageUrl("images/icons/card.svg")} height="40" />
                  )}
                </div>
                <div className={`d-flex flex-column ${style.cardInfo}`}>
                  <span className="font-weight-bold test-card-number">
                    {card.brand} ****{card.last4_number}
                  </span>
                  <span className={style.expires}></span>
                </div>
                <div className="ml-auto">
                  {currentPlan?.plan_name === t("InfoCard.フリー") ? (
                    currentPlan.payment_method === "credit_card" && isDelete ? (
                      <DangerBtn
                        text={t("InfoCard.削除")}
                        loading={loading}
                        submit={deleteFunc}
                        className="test-delete-card mx-1"
                        dataTestId="test-delete-card-btn"
                        style={{
                          padding: "3px 10px",
                          borderRadius: "30px",
                          minWidth: "68px",
                          minHeight: "38px",
                          height: "auto",
                          fontWeight: 600,
                        }}
                      />
                    ) : (
                      <SecondaryBtn
                        text={t("InfoCard.変更")}
                        submit={changeFunc}
                        className="test-change-card mx-1"
                        disabled={loading ? true : false}
                        style={{
                          padding: "3px 10px",
                          borderRadius: "30px",
                          minWidth: "68px",
                          minHeight: "38px",
                          height: "auto",
                          fontWeight: 600,
                        }}
                        dataTestId="test-register-card-btn"
                      />
                    )
                  ) : (
                    <SecondaryBtn
                      text={t("InfoCard.変更")}
                      submit={changeFunc}
                      className="test-change-card mx-1"
                      disabled={loading ? true : false}
                      style={{
                        padding: "3px 10px",
                        borderRadius: "30px",
                        minWidth: "68px",
                        minHeight: "38px",
                        fontWeight: 600,
                        height: "auto",
                      }}
                      dataTestId="test-register-card-btn"
                    />
                  )}
                </div>
              </>
            ) : (
              <>
                <div className={`d-flex flex-column ${style.cardInfo}`}>
                  <span
                    className="test-card-number"
                    style={{ color: "#cacaca" }}
                    dangerouslySetInnerHTML={{
                      __html: t("InfoCard.クレジットカードが登録されていません"),
                    }}
                  />
                  <span className={style.expires}></span>
                </div>
                {!is_internal && currentPlan?.plan_name !== t("InfoCard.フリー") ? (
                  <div className="ml-auto">
                    <SecondaryBtn
                      text={t("InfoCard.登録")}
                      submit={changeFunc}
                      className="test-change-card mx-1"
                      disabled={loading ? true : false}
                      style={{
                        padding: "3px 10px",
                        borderRadius: "30px",
                        minWidth: "68px",
                        minHeight: "38px",
                        height: "auto",
                        fontWeight: 600,
                      }}
                      dataTestId="test-register-card-btn"
                    />
                  </div>
                ) : (
                  <div className="ml-auto">
                    <SecondaryBtn
                      text={t("InfoCard.登録")}
                      submit={changeFunc}
                      className="test-change-card mx-1"
                      disabled={card === "" ? true : loading ? true : false}
                      style={{
                        padding: "3px 10px",
                        borderRadius: "30px",
                        minWidth: "68px",
                        minHeight: "38px",
                        height: "auto",
                        fontWeight: 600,
                      }}
                      dataTestId="test-register-card-btn"
                    />
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

InfoCard.propTypes = {
  card: PropTypes.object,
  isDelete: PropTypes.bool,
  loading: PropTypes.bool,
  deleteFunc: PropTypes.func,
  changeFunc: PropTypes.func,
  paymentMethod: PropTypes.string,
  styles: PropTypes.object,
  currentPlan: PropTypes.object,
  is_internal: PropTypes.bool,
};
